export function waitDocumentLoad(): Promise<void> {
	if (document.readyState === "complete") {
		return Promise.resolve()
	}
	return new Promise((resolve) => document.addEventListener("DOMContentLoaded", () => resolve()))
}
